export default __webpack_public_path__ + "static/media/nis_m.634f8c45.jpg";